import { DescriptionEditorWithCompare } from './description-editor-with-compare';

export const DescriptionEditor = ({
  description,
  updateDescription,
  className,
}: {
  description: string;
  updateDescription: ({ body }: { body: string }) => void;
  className?: string;
}) => {
  return (
    <DescriptionEditorWithCompare
      description={description}
      updateDescription={updateDescription}
      className={className}
    />
  );
};
